import React, { useState } from "react";

const objectiveContext = React.createContext({});

const ObjectiveProvider = ({ children }) => {
  const [solutionActive, setSolutionActive] = useState(false);
  const [companyActive, setCompanyActive] = useState(false);
  const [modalStatus, setModalStatus] = useState(true);
  return (
    <objectiveContext.Provider
      value={{
        solutionActive,
        setSolutionActive,
        companyActive,
        setCompanyActive,
        modalStatus,
        setModalStatus,
      }}
    >
      {children}
    </objectiveContext.Provider>
  );
};

export { objectiveContext, ObjectiveProvider };
